import { Injectable } from "@angular/core";
import { Response, Http, Headers, RequestOptions, } from "@angular/http";

import "rxjs/add/operator/toPromise";
import { Observable, of, throwError } from "rxjs";

import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/observable/throw";
//import { ErrorObservable } from "rxjs/observable/ErrorObservable";
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from "@angular/common/http";
//import { pipe } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { DialogService } from "./dialog.service";
//import { switchMap } from "rxjs-compat/operator/switchMap";

@Injectable({
    providedIn: "root"
})
export class CallHttp {
    constructor(private http: HttpClient, private dialogService: DialogService) { }

    httpPutFileShare<TResponse>(url: string, contentBody: any, contentType: string): Observable<TResponse> {
        let resp: TResponse = null;
        //Content-type
        const headers = new HttpHeaders({ 'Content-type': contentType });
        var retorna: Observable<TResponse> = this.http.put<TResponse>(url, contentBody, { headers: headers, withCredentials: false })
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    }

    httpGet<TResponse>(url: string, param?: string, options?: { withCredentials: boolean; }): Observable<TResponse> {
        let urlGet: string = (param == null) ? url : url + "?" + param;
        let resp: TResponse = null;

        var retorna: Observable<TResponse> = this.http.get<TResponse>(urlGet)//: Observable<TResponse> =
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    }

    httpGetParams<TResponse>(url: string, object: any): Observable<TResponse> {
        let params = new HttpParams({ fromObject: object });
        //let urlGet: string = (param == null) ? url : url + "?" + param;
        let resp: TResponse = null;

        var retorna: Observable<TResponse> = this.http.get<TResponse>(url, { params: params })//: Observable<TResponse> =
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    }

    httpGetText(url: string, param: string = null): Observable<string> {
        let urlGet: string = (param == null) ? url : url + "?" + param;
        let resp = null;

        var retorna: Observable<string> = this.http.get(urlGet, { responseType: 'text' })
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    }

    //httpGetFile<TResponse>(url: string, param: string = null): Observable<TResponse> {
    //    let urlGet = (param == null) ? url : url + "?" + param;
    //    var retorna = this.http.get(urlGet)
    //        .map(res => res.blob())
    //        .catch(this.handleError)
    //    return retorna;
    //}

    
    httpPost<TResponse>(url: string, contentBody?: any, options?: { withCredentials: boolean; }): Observable<TResponse> {
        let resp: TResponse = null;

        var retorna: Observable<TResponse> = this.http.post<TResponse>(url, contentBody)
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    }

    httpPostFormData<TResponse>(url: string, contentBody: any): Observable<TResponse> {
        const headers = new HttpHeaders({ 'enctype': 'multipart/form-data' });
        headers.append('Accept', 'application/json');
        let resp: TResponse = null;

        //headers ?: Headers
        //const options = new RequestOptions({ headers: headers });

        var retorna: Observable<TResponse> = this.http.post<TResponse>(url, contentBody, { headers: headers })
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    }


    httpPostFormDataText(url: string, contentBody: any): Observable<string> {
        const headers = new HttpHeaders({ 'enctype': 'multipart/form-data' });
        headers.append('Accept', 'application/json');
        let resp: string = null;

        //headers ?: Headers
        //const options = new RequestOptions({ headers: headers });

        var retorna: Observable<string> = this.http.post(url, contentBody, { headers: headers, responseType: 'text' })
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    }

    httpPostText(url: string, contentBody: any): Observable<string> {
        let resp = null;

        var retorna: Observable<string> = this.http.post(url, contentBody, { responseType: 'text' })
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    }

    private extractData<T>(res: Response): any {
        let body: any = CallHttp.isJsonString(res) ? res.json() : res.text();
        return body;
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            //this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            let msj = "";
            if (error.error) {
                if (error.error.Message == undefined && error.statusText != "Unknown Error" && (error.status == 404 || error.status == 412)) {
                    var keysObject = Object.keys(error.error);
                    for (let k of keysObject) {
                        msj += k + " - " + (error.error[k] as Array<string>).reduce((r, n, i) => r + "<br />" + n) + "<br />";
                    }
                } else if (error.status == 400) {//+++
                    msj = error.error.Exception.Message;//+++
                }else if (error.error.text) {
                    msj = error.error.text;
                } else {
                    msj = error.message;
                }
                if (error.error.Message != undefined) msj = error.error.Message;
                if (msj == "") msj = `${error.status} - ${error.statusText}`;

                //msj = error.error.Message != undefined ? error.error.Message : (msj == "") ? error.message : msj;
            } else {
                msj = error.message;
            }

            return throwError(msj); //of(result as T);
        };
    }

    //private handleError(error: Response | any): ErrorObservable {
    //    // in a real world app, we might use a remote logging infrastructure
    //    let errMsg: string;
    //    error instanceof Response;
    //    if (error instanceof Response) {   
    //        // const body = error.json() || "";
    //        // const err = body.error || JSON.stringify(body);
    //        errMsg = `${error.status} - ${error.statusText || ""}`;// ${err}
    //    } else {
    //        errMsg = error.message ? error.message : error.toString();
    //    }
    //    console.error(errMsg);
    //    return Observable.throw(errMsg);
    //}

    public static isJsonString(str): boolean {
        try {
            str.json()
        } catch (e) {
            return false;
        }
        return true;
    }
}

